(function () {
  var STYLE_ID = 'aeryon-upcart-hide-discounts';
  var CSS =
    '.upcart-internal-cart-summary__discount-codes,' +
    '.upcart-public-cart-summary__discount-codes,' +
    '.upcart-internal-cart-summary__total-discount,' +
    '.upcart-public-cart-summary__total-discount{display:none!important;}';

  function inject(root) {
    if (!root || root.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    (root.querySelector('head') || root).appendChild(style);
  }

  function apply() {
    var host = document.querySelector('#upCart') || document.querySelector('#upcart');
    if (host && host.shadowRoot) {
      inject(host.shadowRoot);
      return true;
    }
    var nodes = document.querySelectorAll('[id]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var id = (el.id || '').toLowerCase();
      if (id.indexOf('upcart') !== -1 && el.shadowRoot) {
        inject(el.shadowRoot);
        return true;
      }
    }
    return false;
  }

  function start() {
    apply();
    var tries = 0;
    var id = setInterval(function () {
      tries += 1;
      if (apply() || tries > 80) clearInterval(id);
    }, 250);
    document.addEventListener(
      'click',
      function () {
        setTimeout(apply, 50);
        setTimeout(apply, 400);
      },
      true
    );
    if (typeof window.upcartSubscribeCartOpened === 'function') {
      try {
        window.upcartSubscribeCartOpened(function () {
          setTimeout(apply, 50);
          setTimeout(apply, 400);
        });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
